
import React from 'react';

import {Helmet} from 'views/module';

import ClientScheduleDashboard from 'views/scenes/schedule/client/ClientScheduleDashboard';

const ClientScheduleDashboardPage = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <ClientScheduleDashboard
      />
    </>
  );
};

export default ClientScheduleDashboardPage;
